/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import {REQUEST_ADDRESS, REQUEST_ADDRESS_TYPES, REQUEST_ADDRESSES_BY_IDS} from './constants';

export const initialState = {
  addressTypes: [],
  addresses: {},
};

export const addressReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_ADDRESS_TYPES:
            if (action.result) {
              draft.addressTypes = action.result;
              localStorage.setItem('address-types', JSON.stringify(action.result));
            }
            break;

          case REQUEST_ADDRESS:
            draft.addresses[action.addressId] = action.result;
            break;

          case REQUEST_ADDRESSES_BY_IDS:
            action.result.forEach(address => {
              draft.addresses[address.id] = address;
            });
            break;
        }
    }
  });
